import { Injectable } from '@angular/core';
import { HttpClient,HttpHeaders } from '@angular/common/http';
import {ConsignorElement} from "../models/ConsignorModel";

import { environment } from '../../environments/environment';

@Injectable()
export class ConsignorService {

  private apiUrl = environment.apiUrl;

  constructor(private http: HttpClient) { }



  /////////////////////////////  ------------- CURD OPERATIONS -----------------

  insertConsignorData(bra:ConsignorElement) {
    var httpOptions = {
      headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Credentials': 'true',
          'Access-Control-Allow-Headers': 'Content-Type',
          'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE',
          'key': 'x-api-key',
          'value': 'NNctr6Tjrw9794gFXf3fi6zWBZ78j6Gv3UCb3y0x',

      })
  };
  return this.http.post(""+this.apiUrl+"/ConsignorMaster/AddConsignorMaster",
  JSON.stringify(bra),
   httpOptions
  )
  }


  /////////////////////////  ------------  GET ALL ------------

  getAllConsignorData() {
    var httpOptions = {
      headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Credentials': 'true',
          'Access-Control-Allow-Headers': 'Content-Type',
          'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE',
          'key': 'x-api-key',
          'value': 'NNctr6Tjrw9794gFXf3fi6zWBZ78j6Gv3UCb3y0x',

      })
  };
    return this.http.get(""+this.apiUrl+"/ConsignorMaster/GetAllConsignorMaster",httpOptions);
  }


  getAllConsignorMasterByUserIdData(userid:number) {
    var httpOptions = {
      headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Credentials': 'true',
          'Access-Control-Allow-Headers': 'Content-Type',
          'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE',
          'key': 'x-api-key',
          'value': 'NNctr6Tjrw9794gFXf3fi6zWBZ78j6Gv3UCb3y0x',

      })
  };
    return this.http.get(""+this.apiUrl+"/ConsignorMaster/GetAllConsignorMasterByUserId?CreatedBy="+userid,httpOptions);
  }


  getAllConsignorMasterByConsignorIdData(id:number) {
    var httpOptions = {
      headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Credentials': 'true',
          'Access-Control-Allow-Headers': 'Content-Type',
          'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE',
          'key': 'x-api-key',
          'value': 'NNctr6Tjrw9794gFXf3fi6zWBZ78j6Gv3UCb3y0x',

      })
  };
    return this.http.get(""+this.apiUrl+"/ConsignorMaster/GetAllConsignorMasterByConsignorId?ConsignorId="+id,httpOptions);
  }


}
